module.exports = __webpack_public_path__ + "static/img/maximus-ch.23759d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maximus-ch.png
// module id = CIQU
// module chunks = 15